import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSpuGroupList, updateSpuGroup, updateSpuGroupStatus, createSpuGroup, deleteSpuGroup, getGoodsspuList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'BianlidianGoodsspuGroup',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSpuGroupList,
      searchSpuOptions: [],
      searchSpuNoArr: [],
      selSpuOptions: [],
      dialogVisible: false,
      dialogTitle: '',
      type: '',
      expandRowKeys: [],
      formData: {
        spuGroupNo: '',
        spuGroupName: '',
        isHot: 2
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {// 使用keepalive的页面,重新展示不会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onRowClick: function onRowClick(row, column) {
      if (!row.hasExpand) {
        row.hasExpand = true;
        this.expandRowKeys = [row.spuGroupNo];
      } else {
        row.hasExpand = false;
        this.expandRowKeys = [];
      }
    },
    onSearchSpu: function onSearchSpu(query) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(query != '')) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return getGoodsspuList({
                  'goodsName': query,
                  'page': 1,
                  'pageSize': 20
                });

              case 3:
                res = _context3.sent;

                if (res.code == 0) {
                  _this2.searchSpuOptions = res.data.list || [];
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onChangeSearchSpu: function onChangeSearchSpu() {
      var _this3 = this;

      var temp = this.searchSpuOptions.concat(this.selSpuOptions);
      var uniqueArr = temp.filter(function (obj, index) {
        // 去重
        return temp.findIndex(function (item) {
          return item.spuNo === obj.spuNo;
        }) === index;
      });
      this.selSpuOptions = uniqueArr.filter(function (item) {
        return _this3.searchSpuNoArr.includes(item.spuNo);
      });
      this.$nextTick(function () {
        var dom = document.querySelector('.search-spu .el-select__tags-text');
        if (dom) dom.innerText = '已选中' + _this3.searchSpuNoArr.length;
      });
    },
    onTagClose: function onTagClose(spuNo) {
      this.searchSpuNoArr = this.searchSpuNoArr.filter(function (item) {
        return item !== spuNo;
      });
      this.onChangeSearchSpu();
    },
    onAdd: function onAdd() {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
      this.type = 'add';
    },
    onUpdate: function onUpdate(row) {
      this.dialogVisible = true;
      this.dialogTitle = '变更';
      this.type = 'update';
      this.formData.spuGroupNo = row.spuGroupNo;
      this.formData.spuGroupName = row.spuGroupName;
      this.formData.isHot = row.isHot;
      this.searchSpuNoArr = row.spuNoStr.split(',');
      this.selSpuOptions = JSON.parse(JSON.stringify(row.spuList));
      this.onChangeSearchSpu();
    },
    onStatus: function onStatus(row, status) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return updateSpuGroupStatus({
                  'spuGroupNo': row.spuGroupNo,
                  'spuGroupStatus': status
                });

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  _this4.$message({
                    type: 'success',
                    message: '操作成功'
                  });

                  _this4.onSubmit();
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onDelete: function onDelete(row) {
      var _this5 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return deleteSpuGroup({
                  'spuGroupNo': row.spuGroupNo
                });

              case 2:
                res = _context5.sent;

                if (res.code == 0) {
                  _this5.$message({
                    type: 'success',
                    message: '操作成功'
                  });

                  _this5.onSubmit();
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.dialogUpdateVisible = false;
      this.searchSpuOptions = [];
      this.searchSpuNoArr = [];
      this.selSpuOptions = [];
      this.formData = {
        spuGroupNo: '',
        spuGroupName: ''
      };
    },
    enterDialog: function enterDialog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, _res;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this6.type === 'add')) {
                  _context6.next = 15;
                  break;
                }

                if (!(_this6.formData.spuGroupName.trim() === '')) {
                  _context6.next = 4;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请输入分组名称'
                });

                return _context6.abrupt("return");

              case 4:
                if (!(_this6.searchSpuNoArr.length === 0)) {
                  _context6.next = 7;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请搜索选择商品'
                });

                return _context6.abrupt("return");

              case 7:
                _context6.next = 9;
                return createSpuGroup({
                  'spuGroupName': _this6.formData.spuGroupName,
                  'spuNoStr': _this6.searchSpuNoArr.join(','),
                  'isHot': _this6.formData.isHot
                });

              case 9:
                res = _context6.sent;

                if (!(res.code == 0)) {
                  _context6.next = 15;
                  break;
                }

                _this6.$message({
                  type: 'success',
                  message: '操作成功'
                });

                _this6.closeDialog();

                _this6.onSubmit();

                return _context6.abrupt("return");

              case 15:
                if (!(_this6.type === 'update')) {
                  _context6.next = 30;
                  break;
                }

                if (!(_this6.formData.spuGroupName.trim() === '')) {
                  _context6.next = 19;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请输入分组名称'
                });

                return _context6.abrupt("return");

              case 19:
                if (!(_this6.searchSpuNoArr.length === 0)) {
                  _context6.next = 22;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请搜索选择商品'
                });

                return _context6.abrupt("return");

              case 22:
                _context6.next = 24;
                return updateSpuGroup({
                  'spuGroupNo': _this6.formData.spuGroupNo,
                  'spuGroupName': _this6.formData.spuGroupName,
                  'spuNoStr': _this6.searchSpuNoArr.join(','),
                  'isHot': _this6.formData.isHot
                });

              case 24:
                _res = _context6.sent;

                if (!(_res.code == 0)) {
                  _context6.next = 30;
                  break;
                }

                _this6.$message({
                  type: 'success',
                  message: '操作成功'
                });

                _this6.closeDialog();

                _this6.onSubmit();

                return _context6.abrupt("return");

              case 30:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};